import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 6a1 1 0 0 1 -1 1h-16a1 1 0 1 1 0 -2h16a1 1 0 0 1 1 1","key":"svg-0"}],["path",{"d":"M21 12a1 1 0 0 1 -1 1h-16a1 1 0 0 1 0 -2h16a1 1 0 0 1 1 1","key":"svg-1"}],["path",{"d":"M21 18a1 1 0 0 1 -1 1h-16a1 1 0 0 1 0 -2h16a1 1 0 0 1 1 1","key":"svg-2"}]]

const IconMenu2Filled = createReactComponent('filled', 'menu-2-filled', 'Menu2Filled', __iconNode);

export default IconMenu2Filled;